import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { api } from '../config/api';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/auth.php?action=login', formData);

      if (response.data.success) {
        const user = response.data.user;
        localStorage.setItem('user', JSON.stringify(user));

        // Redirect based on role
        if (user.role === 'admin') {
          const adminUrl = window.location.hostname === 'localhost' && window.location.port === '3000'
            ? 'http://localhost:5173'
            : '/syra%20food%20point%20seguku/admin/dist/';
          window.location.href = adminUrl;
        } else {
          navigate('/');
        }
      } else {
        setError(response.data.message || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Unable to connect to server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center" style={{ backgroundColor: '#faf8f5' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card border-0" style={{ backgroundColor: '#ffffff', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
              <div className="card-body p-5">
                <div className="text-center mb-5">
                  <div className="mb-3">
                    <span style={{ fontSize: '2.5rem', color: '#D4AF37' }}>✦</span>
                  </div>
                  <h1 className="fw-bold mb-2" style={{ fontFamily: 'Playfair Display, serif', fontSize: '2rem', fontWeight: 600 }}>
                    Welcome Back
                  </h1>
                  <p className="text-muted">Sign in to your account</p>
                </div>

                {error && (
                  <div style={{
                    backgroundColor: '#FFEBEE', color: '#C62828', padding: '12px 16px',
                    borderRadius: '10px', fontSize: '0.85rem', marginBottom: '20px', textAlign: 'center'
                  }}>
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label className="form-label" style={{ fontWeight: 500, fontSize: '0.9rem' }}>Email Address</label>
                    <div style={{ position: 'relative' }}>
                      <Mail size={16} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#999' }} />
                      <input
                        type="email" className="form-control" name="email"
                        value={formData.email} onChange={handleChange} required
                        placeholder="you@example.com"
                        style={{ padding: '12px 16px 12px 42px' }}
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="form-label" style={{ fontWeight: 500, fontSize: '0.9rem' }}>Password</label>
                    <div style={{ position: 'relative' }}>
                      <Lock size={16} style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#999' }} />
                      <input
                        type={showPassword ? 'text' : 'password'} className="form-control" name="password"
                        value={formData.password} onChange={handleChange} required
                        placeholder="Enter your password"
                        style={{ padding: '12px 42px 12px 42px' }}
                      />
                      <button type="button" onClick={() => setShowPassword(!showPassword)}
                        style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#999', padding: 0 }}>
                        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                      </button>
                    </div>
                  </div>

                  <button
                    type="submit" disabled={loading}
                    className="btn text-white w-100 mb-4"
                    style={{
                      backgroundColor: loading ? '#ccc' : '#D4AF37',
                      border: 'none', padding: '14px 32px',
                      fontSize: '1rem', letterSpacing: '1px',
                      textTransform: 'uppercase', fontWeight: 600,
                      borderRadius: '2px', boxShadow: '0 4px 20px rgba(212, 175, 55, 0.3)',
                      cursor: loading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {loading ? 'Signing in...' : 'Sign In'}
                  </button>

                  <p className="text-center mb-0">
                    Don't have an account? <Link to="/register" className="fw-bold" style={{ color: '#D4AF37', textDecoration: 'none' }}>Register here</Link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
